import React from 'react';
import { number, string, arrayOf, shape, func } from 'prop-types';
import { brandType, currencyType } from 'common/propTypes';
import { SummaryLine } from '../SummaryLine';
import { GiftCardLeft } from '../../../payment/components/SelectPayment';
import formatPaymentProviderText from '../../utils/format-payment-text';
import formatPrice from '../../utils/format-price';
import formatCard from '../../../payment/utils/formatCard';
import { giftCardStatus } from '../../utils/gift-card-status';
import { useContent } from '../../../content/content-provider';

const PaymentsMade = ({ payments, giftCards, brands, cardPrefix, currency, removeGiftCard }) => {
  const [content] = useContent();

  return (
    <>
      {!!payments.length && (
        <>
          {payments.map(
            ({ desc, amount, pending }) =>
              !pending && (
                <SummaryLine
                  key={desc}
                  leftContent={formatPaymentProviderText(desc, brands, cardPrefix)}
                  rightContent={`-${formatPrice(amount, currency)}`}
                  isPayment
                />
              )
          )}
        </>
      )}
      {giftCards.map(({ cardNumber, redemptionAmount, status }) => (
        <SummaryLine
          key={`giftcard-${formatCard(cardNumber).slice(2)}`}
          status={giftCardStatus[status]}
          leftContent={<GiftCardLeft cardNumber={cardNumber} removeGiftCard={removeGiftCard} />}
          rightContent={
            status === 'REDEMPTION_FAILURE'
              ? content.status.redemptionFailure
              : `-${formatPrice(redemptionAmount, currency)}`
          }
        />
      ))}
    </>
  );
};

PaymentsMade.propTypes = {
  currency: currencyType.isRequired,
  giftCards: arrayOf(
    shape({
      cardNumber: string.isRequired,
      redemptionAmount: number.isRequired,
    })
  ).isRequired,
  removeGiftCard: func,
  payments: arrayOf(
    shape({
      desc: string.isRequired,
      amount: number.isRequired,
    })
  ),
  brands: brandType,
  cardPrefix: string,
};

PaymentsMade.defaultProps = {
  payments: [],
  removeGiftCard: null,
  brands: {},
  cardPrefix: '',
};

export default PaymentsMade;
